import { useContext, useState } from "react";
import { ObjectContext } from "@providers/ObjectProvider";
import Avatar from '@mui/joy/Avatar';
import Chip from '@mui/joy/Chip';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import CardOverflow from '@mui/joy/CardOverflow';
import CardActions from '@mui/joy/CardActions';
import IconButton from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import SvgIcon from '@mui/joy/SvgIcon';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/joy/Tooltip';
import Table from '@mui/joy/Table';
import Stack from '@mui/joy/Stack';
import ObjectRelationshipCard from '@components/objects/ObjectRelationshipCard';
import { gradientTint } from "@utils/gradientTint";
import { useGetUser } from "@api/userService";
import AbstractObjectRelationship from "./AbstractObjectRelationship";
import { Alert, LinearProgress } from "@mui/joy";
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import GppBadRoundedIcon from '@mui/icons-material/GppBadRounded';
import { yesNo } from "@utils/yesNo";
import { userRoles } from "@utils/selectOptions";

export default function UserAccessCard({
  // relationship,
  title,
  tint = null,
}) {
  // const isEmpty = !relationship;
  const data = useContext(ObjectContext);
  const userId = data?.user_id ?? 0;

  // TODO: put this into an effect and only load it once
  const {
    // isPending,
    isLoading,
    isError,
    error,
    data: userData,
    isFetching,
    isPreviousData,
  } = useGetUser(userId, {
    enabled: userId > 0,
    retry: false,//1,
  });

  const shortName = data?.first_name ?? data?.name ?? 'N/A';
  const hasAccess = userId > 0 && userData;

  /*

    const {
        // isPending,
        isLoading,
        isError,
        error,
        data: searchResults,
        isFetching,
        isPreviousData,
    } = useGetAll({
        queryKey: ['search', debouncedSearchTerm],
        enabled: debouncedSearchTerm.length > 0,
    }, {
        term: debouncedSearchTerm,
    });
  */

  const getRolesForUser = ():string => {
    if(!userData?.roles?.[0]) {
      return 'N/A';
    }

    let roles:string[] = [];

    userData.roles.map(role => {
      const findRole = userRoles.find(r => r.value === role.id);
      roles.push(findRole?.label ?? role.name);
    });

    return roles.join(', ');

    /*
    {userData?.roles?.map((role, roleInd) => (
      <span key={roleInd}>{userRoles.find(role => role.value === role.id)?.label ?? 'N/A'}</span>
    ))[0]?.name ?? 'N/A'}
    return '';
    */
  }

  return (
    <AbstractObjectRelationship title={'User Access'}>
      {isLoading && (<Box p={1.6}><LinearProgress/></Box>)}
      {!isLoading && isError && (
        <Alert
        color="danger"
        size="md"
        variant="plain"
      >
        {(error?.response?.status ?? 0) === 403 && (<>This contact is assigned to a user that you cannot access. Please contact Maestro Support.</>)}
        {(error?.response?.status ?? 0) === 404 && (<>This contact is assigned to a user that appears to have been deleted. Please contact Maestro Support.</>)}
        {(error?.response?.status ?? 0) >= 500 && (<>An unknown error has occurred. Please contact Maestro Support if this continues.</>)}
        </Alert>
      )}
      {!isLoading && !isError && (<>
        {!hasAccess && (<>
          <Alert
            variant="plain"
            color="neutral"
            startDecorator={<GppBadRoundedIcon />}
            sx={{px: 1}}
          >
            {shortName} does not have access to Maestro.
          </Alert>
          {/*
          <CardContent sx={{ alignItems: 'center', textAlign: 'center', px: 2 }}>
            <Typography fontSize={'sm'}>This contact does not have access to Maestro.</Typography>
          </CardContent>
          */}
        </>)}
        {hasAccess && (<>
          <Alert
            variant="plain"
            color="success"
            startDecorator={<VerifiedUserRoundedIcon />}
            sx={{px: 1}}
          >
            {shortName} has access to Maestro.
          </Alert>
          <Table
          // stickyHeader
          stripe="odd"
          // hoverRow
          sx={{
            margin: 0,
            padding: 0,
            tableLayout: 'auto',
          }}
        >
          <tbody>
            {/*
            <tr>
              <td colSpan={2}>This contact has access to Maestro.</td>
            </tr>
            */}
            <tr>
              <td className="min">
                <Typography fontSize={'sm'} fontWeight={'bold'}>Role</Typography>
              </td>
              <td>{getRolesForUser()}</td>
            </tr>
            <tr>
              <td className="min">
                <Typography fontSize={'sm'} fontWeight={'bold'}>Staff Member?</Typography>
              </td>
              <td>{yesNo(data?.is_staff)}</td>
            </tr>
          </tbody>
        </Table>
        </>)}
      </>)}
    </AbstractObjectRelationship>
  );
}
